import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import LocalStorageConnection from "./database/localStorage";
import Model from "./model/model.js";

// Ensure React is properly initialized
if (typeof window !== 'undefined') {
  window.React = React;
  window.ReactDOM = ReactDOM;
}

const model = new Model();

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('ServiceWorker registration successful');
      })
      .catch(err => {
        console.log('ServiceWorker registration failed: ', err);
      });
  });
}

// Ensure the root element exists
const rootElement = document.getElementById("root");
if (!rootElement) throw new Error('Failed to find the root element');

// Create root and render
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <LocalStorageConnection model={model} />
    <App model={model} />
  </React.StrictMode>
);
